import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const float = defineConnector({
  identifier: "float",
  name: "Float",
  tagLine: "Resource planning and scheduling",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.float\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Float API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Float](https://app.float.com/) and go to **Team Settings → Integrations → Personal API Token** to generate a new token.",
        },
      ],
    },
    {
      title: "Connect your Float account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Float instance details and API credentials.",
        },
        {
          kind: "input",
          label: "App Details",
          placeholder: "your-appDetails",
          required: true,
          target: { kind: "configuration", field: "appDetails" },
          helperText: "The details of your app",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder:
            "c9b38e5af69912d0rq9tE/fbT5/RPLk8Ua7tfHo9s6xMiCKvmCOvenR/Krc=",
          helperText: "The API key for your Float account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.float.com/v3/tasks",
  },
});
